import styled from 'styled-components/macro'

import { TextField } from '@loadsmart/loadsmart-ui'

export const Input = styled(TextField)``

export const InputGroup = styled.div`
  label {
    display: block;
  }

  ${Input},
  input {
    width: 100%;
  }
`
